import { PlaceType } from '@hcs/types';

export interface GeoBoundaryOption {
  label: string;
  value: string;
}
export const GeoBoundaryCity = {
  label: 'City',
  value: PlaceType.City,
};
export const GeoBoundaryZipcode = {
  label: 'Zipcode',
  value: PlaceType.Zipcode,
};
export const GeoBoundaryMsa = {
  label: 'MSA',
  value: 'MSA',
};
